import FirebaseConfig from "../firebaseConfig";

export async function getEmail(email, callback) {
  const password = "111111";
  FirebaseConfig.auth()
    .createUserWithEmailAndPassword(email, password)
    .then(() => {
      FirebaseConfig.auth().sendPasswordResetEmail(email);
      callback(true);
    })
    .catch((error) => {
      console.log(error);
      callback(false);
    });
}

export async function resetPassword(email, callback) {
  FirebaseConfig.auth()
    .sendPasswordResetEmail(email)
    .then(() => {
      callback(true);
    })
    .catch((error) => {
      callback(false);
    });
}

export function isEmailVerified() {
  let user = localStorage.getItem("token");
  let email_verified = user.emailVerified;
  return email_verified;
}
